const createFavoriteAssetsApi = ({ favoriteAssets }) => {
  return {
    favoriteAssets: {
      favorite: favoriteAssets.favorite,
      unfavorite: favoriteAssets.unfavorite,
    },
  }
}

const favoriteAssetsApiDefinition = {
  id: 'favoriteAssetsApi',
  type: 'api',
  factory: createFavoriteAssetsApi,
  dependencies: ['favoriteAssets'],
}

export default favoriteAssetsApiDefinition
